import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    $('#invoice_resident_id').select2({
      placeholder: 'Select Client...'
    });
    this.initPaySimpleCC();
  }

  checkAchButtonStatus() {
    const route_number = $("#charge_routing_number").val();
    const account_number = $("#charge_account_number").val();
    if (route_number.length > 0 && account_number.length > 0) {
      $("#pay_simple_pay_email_submit_button_ach").prop("disabled", false);
    } else {
      $("#pay_simple_pay_email_submit_button_ach").prop("disabled", true);
    }
  }

  changePaySimpleType() {
    if ($('#pay_simple_payment_type').val() === 'ach') {
      $("#credit_card").hide();
      $("#ach").show();
    } else {
      $("#credit_card").show();
      $("#ach").hide();
    }
  }

  initPaySimpleCC() {
    $('#complete_payment_via_emailed_invoice_pay_simple').each(function(i, elem) {
      const paysimpleMerchantKey = $(elem).data("paysimple-merchant-key");
      const pmt = window.paymentMethodTokenization({
        container: document.querySelector('#pmt'),
        merchantKey: paysimpleMerchantKey
      });
      pmt.trigger.setMode('cc-input');
      pmt.on('add-payment-method-succeeded', function(message) {
        $(elem).append($('<input>', {
          type: 'hidden',
          name: 'payment_source[pay_simple_token_id]',
          value: message.paymentMethodToken
        }));
        elem.submit();
      });
      pmt.on('validity-changed', function(message) {
        $("#pay_simple_pay_email_submit_button").prop("disabled", !message.valid);
      });
      elem.addEventListener('submit', function(e) {
        e.preventDefault();
        pmt.trigger.submitForm();
      });
    });
  }
}
